import en from '../translations/en.json';
import fr from '../translations/fr.json';

const TranslationService = {
  getMessage:  (text: string, language: string) => {
    let translation = fr as any;
    switch (language) {
      case 'en':
        translation = en as any;
        break;
      case 'fr':
      default:
        break;
    }
    return (translation[text] ? translation[text] : text);
  }
}

export default TranslationService;
